<template>
  <page>
    <div slot="head" class="page-head-default">
      <img src="../../assets/imgs/back.png" alt="" @click="goRouter('/wallet')">
      {{$t('mine.prestore')}}
    </div>
    <!-- <div class="wallet-in-warp">
      <div class="wallet-in-prices-warp">
        <div class="wallet-in-label">{{i18n.price_auto}}</div>
        <div class="wallet-in-prices">
          <div class="wallet-in-price" v-for="(item, i) in prices" :key="i" @click="onItem(item)">
            <div :class="{'active': `${item}`===`${price}`}">{{user && user.pcurrencyName}} {{item}}</div>
          </div>
        </div>
        <span class="wallet-in-tips">{{i18n.price_tips}}</span>
        <span class="wallet-in-tips" style="color: #05A6DD;" @click="openProtocol">{{i18n.price_btn}}</span>
      </div>
      <div class="wallet-btn">
        <button class="btn" @click="onSubmit">{{i18n.submit}}</button>
      </div>
    </div> -->
    <div class="wallet-in-warp">
      <div class="wallet-in-vip-card">
        <img class="title" src="../../assets/imgs/vip.png" />
        <div class="tips">{{i18n.vip_tips}}</div>
        <img v-if="user && user.avatarUrl" class="avatar" :src="user.avatarUrl" />
        <img v-else class="avatar" src="../../assets/imgs/avatar_default.png" />
        <img class="vip-card-bg" src="../../assets/imgs/card_info.png" />
      </div>
      <div class="wallet-in-prices-warp">
        <div class="wallet-in-prices">
          <div class="wallet-in-price" :class="{'active': `${item.value}`===`${price}`}" v-for="(item, i) in prices" :key="i" @click="onItem(item)" >
            <img class="active-img" src="../../assets/imgs/blue_check.png" />
            <div class="wallet-in-price-left">
              <div class="title">
                <span class="bold">{{i18n['price_title_' + item.value]}}</span>
                <span>{{i18n['price_' + item.value]}}</span>
              </div>
              <div class="sub-title">{{i18n.price_sub_title.format(item.day)}}</div>
            </div>
            <div class="wallet-in-price-right">{{user && user.pcurrencyName}} {{item.money}} </div>
          </div>
        </div>
      </div>
      <div class="wallet-btn">
        <!-- <button class="btn" @click="onSubmit">{{i18n.submit}}</button> -->
        <button class="btn" v-if="browser === 'mpay'" @click="onSubmit">{{i18n.submit}}</button>
        <button class="btn" v-else @click="onPay">{{i18n.submit}}</button>
      </div>
      <div class="wallet-in-vip">
        <div class="wallet-in-vip-title">
          <img src="../../assets/imgs/left_arr_blue.png" />
          <span>{{i18n.vip_title}}</span>
          <img src="../../assets/imgs/right_arr_blue.png" />
        </div>
        <div class="wallet-in-vip-cont">
          <div>
            <img src="../../assets/imgs/tq_1.png" />
          </div>
          <div>
            <img src="../../assets/imgs/tq_2.png" />
          </div>
        </div>
        <div class="wallet-in-vip-rolu">
          <div class="title">{{i18n.rule_title}}</div>
          <div v-html="i18n.rule_tips"></div>
        </div>
      </div>
    </div>
    <paytype v-if="payTypeShow" ref="paytype" :payTitle="i18nMsg.payVipTitle" :paySubTitle="i18nMsg.payVipSubTitle" :pPrice="prices[price-2].money" :payTypeShow="payTypeShow" @back="onBack" @changeRadio="changeRadio" @goPay="goPay" />
  </page>
</template>

<script>
import { EFTPAY_VIP_ORDER, VIP_ORDER, MPAY_VIP_ORDER, PAYPAL_VIPORDER, WEPAYEZ_VIPORDER } from '../../apis/payment.js'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user', 'browser', 'cabinet', 'area']),
    i18n () {
      return this.$t('wallet_in')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nConfirm () {
      return this.$t('confirm')
    }
  },
  data () {
    return {
      price: 2,
      prices: [{
        value: 2,
        day: 60,
        money: 199
      }, {
        value: 3,
        day: 365,
        money: 828
      }],
      qrcode: '',
      payTypeShow: false,
      payTypeValue: 'AlipayCN',
      pay: process.env.VUE_APP_PAY === '1'
    }
  },
  methods: {
    onItem (item) {
      this.price = item.value
    },
    onBack (v) {
      this.payTypeShow = v
    },
    changeRadio (v) {
      console.log('radio', v.index, v.value)
      this.payTypeValue = v.value
    },
    onPay () {
      this.payTypeShow = true
    },
    goPay (v) {
      this.payTypeValue = v
      this.onSubmit()
    },
    onSubmit (event) {
      if (this.browser === 'mpay') {
        this.mpayVip()
        return
      } else if (this.payTypeValue === 'Paypal') {
        this.onPaypal()
        return
      } else if (this.payTypeValue === 'WeChat') {
        this.onWechat()
        return
      }
      this.$loading(true)
      this.$post(
        this.pay ? EFTPAY_VIP_ORDER : `${VIP_ORDER}?priceId=${this.price}`,
        {
          priceId: this.price,
          apiType: 'H5',
          payChannel: this.payTypeValue,
          returnUrl: window.location.href
        },
        res => {
          this.$loading(false)
          console.log(res)
          if (res && res.pay_apptrade) {
            window.location.href = res.pay_apptrade
          } else {
            this.$toast(res.msg)
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    goRouter (path) {
      this.$router.push(path)
    },
    openProtocol () {
      window.open('https://app.easycharge.com.hk/content/user_agreement.html')
    },
    mpayVip () {
      // let vm = this
      this.$loading(true)
      this.$post(
        `${MPAY_VIP_ORDER}?priceId=${this.price}&apiType=QRCODE&payChannel=mpay`,
        {},
        res => {
          this.$loading(false)
          console.log(res)
          // if (window.mp) {
          //   window.mp.choosePayMent({
          //     paymentData: JSON.parse(res.data.data.pay_info),
          //     success: function (res) { // 支付成功回調 以下是 res 示例
          //       console.log('支付成功----', res)
          //       // vm.$emit('loadlist')
          //       vm.$toast(vm.i18nMsg.success)
          //       // window.location.reload()
          //     },
          //     fail: function (error) {
          //       console.log('mpay支付失败---', error)
          //       vm.$toast(error)
          //     }, // 支付失敗回調
          //     cancel: function (res) { // 以下是 res 內容示例
          //       console.log('mpay取消支付---', res)
          //     } // 取消支付回調
          //   })
          // } else {
          //   this.loadMpayScript(this.mpayVip)
          // }
          if (res.data && res.data.qr_code) {
            window.location.href = res.data.qr_code
          } else {
            this.$toast(res.msg)
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    onPaypal () {
      this.$loading(true)
      let url = PAYPAL_VIPORDER
      this.$post(
        url,
        {
          priceId: this.price
        },
        resp => {
          this.$loading(false)
          if (resp.data) {
            this.$loading(true)
            window.location.href = resp.data.checkOutUrl
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nConfirm.msg_fail_title,
            content: this.i18nConfirm.msg_fail_order,
            confirmText: this.i18nConfirm.msg_fail_retry,
            cancelText: this.i18nConfirm.msg_fail_cancel
          }).then(() => {
            this.onPaypal()
          })
          console.log(error)
        }
      )
    },
    onWechat () {
      this.$loading(true)
      let url = `${WEPAYEZ_VIPORDER}?priceId=${this.price}`
      this.$post(
        url,
        {},
        resp => {
          this.$loading(false)
          if (resp.data) {
            this.$loading(false)
            this.$confirmqr({
              title: this.i18nConfirm.msg_fail_title,
              text: resp.data.code_url,
              tip: this.i18nMsg.confirmpaytip,
              confirmText: this.i18nConfirm.msg_fail_payconfirm,
              cancelText: this.i18nConfirm.msg_fail_cancel
            }).then(() => {
              this.payTypeShow = false
            })
            // window.location.href = resp.data.code_url
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nConfirm.msg_fail_title,
            content: this.i18nConfirm.msg_fail_order,
            confirmText: this.i18nConfirm.msg_fail_retry,
            cancelText: this.i18nConfirm.msg_fail_cancel
          }).then(() => {
            this.onWechat()
          })
          console.log(error)
        }
      )
    }
  },
  created () {
    this.$loading(false)
    this.qrcode = this.$route.query.qrcode || ''
  }
}
</script>

<style lang="less">
.wallet-in-warp {
  padding: 46px;
  background-image: url(../../assets/imgs/icon_top.png);
  background-repeat:no-repeat;
  background-size: 100% 350px;
}
.wallet-in-title {
  color: #FFFFFF;
  font-size: 48px;
  padding: 60px 40px 10px;
}
.wallet-form{
  background: #FFFFFF;
  padding: 40px 40px 0;
}
.wallet-label{
  font-size: 32px;
  font-weight: 400;
  color: rgba(51,51,51,1);
}
.wallet-input{
  padding-top: 20px;
  display: flex;
  align-items: center;
  font-size: 56px;
  font-weight: 500;
  color:rgba(52,125,255,1);
}
.wallet-input span{
  height: 78px;
  line-height: 78px;
}
.wallet-input input{
  flex: 1;
  height: 78px;
  line-height: 78px;
  color: rgb(52, 125, 255);
  font-size: 56px;
}
.wallet-balance{
  background: #FFFFFF;
  border-top: 1px solid rgba(217,217,217,1);
  font-size: 32px;
  font-weight: 400;
  color: rgba(51,51,51,1);
  padding: 26px 40px;
}
.wallet-balance span{
  font-size: 36px;
  font-weight: 500;
  color: rgba(241,52,52,1);
}
.wallet-in-prices-warp{
  margin-top: 50px;
  background: #FFFFFF;
  // padding: 26px 40px;
  font-size: 32px;
  font-weight: 400;
  color: #5E5E66;
  border-radius: 20px;
  box-shadow:0px 6px 16px rgba(125,146,196,0.4);
}
.wallet-in-prices{
  .wallet-in-price{
    position: relative;
    display: flex;
    padding: 24px 36px;
    align-items: center;
    .wallet-in-price-left {
      flex: 1;
      .title {
        color: #353535;
        font-size: 36px;
        .bold {
          font-weight: 600;
        }
      }
      .sub-title {
        font-size: 28px;
      }
    }
    .wallet-in-price-right {
      color: #05a6dd;
      font-size: 36px;
      font-weight: 600;
    }
    .active-img {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      width: 46px;
      height: 46px;
    }
  }
  .active {
    border: 1px solid #05a6dd;
    border-radius: 20px;
    .wallet-in-price-right {
      color: #ff0000;
    }
    .active-img {
      display: block;
    }
  }
}
.wallet-btn {
  padding: 55px;
  button {
    width: 100%;
    border: none;
    padding: 0;
    margin: 0;
  }
}
.wallet-in-tips {
  display: flex;
  font-size: 28px;
  color: #F56C6C;
}
.wallet-in-vip-card {
  position: relative;
  box-shadow:0px 6px 16px rgba(125,146,196,0.4);
  .vip-card-bg {
    display: block;
    width: 100%;
    height: 330px;
  }
  .title {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 304px;
    height: 64px;
  }
  .tips {
    position: absolute;
    bottom: 24px;
    left: 48px;
    font-size: 24px;
    color: #565656;
  }
  .avatar {
    width: 100px;
    height: 100px;
    border-radius:50px;
    position: absolute;
    top: 48px;
    left: 36px;
  }
}
.wallet-in-vip {
  &-title {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #05A6DD;
    font-size: 40px;
    font-weight: 600;
    img {
      width: 100px;
      height: 20px;
      margin: 0 20px;
      vertical-align: middle;
    }
  }
  &-cont {
    display: flex;
    justify-content: space-between;
    color: #05A6DD;
    text-align: center;
    font-size: 28px;
    padding: 40px 0;
    div {
      width: 50%;
    }
    img {
      display: block;
      width: 224px;
      height: 227px;
      margin: auto;
    }
  }
  &-rolu {
    color: #6a6a6a;
    font-size: 32px;
    white-space: pre-wrap;
    .title {
      font-size: 40px;
      font-weight: 600;
      padding-bottom: 10px;
    }
  }
}
</style>
